import React from 'react'
import PropTypes from 'prop-types'
import EmblaCarousel from './embla/emblaCarousel'
import { PrismicRichText, PrismicLink } from '@prismicio/react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { format, parseISO } from 'date-fns'

import Info from './svg/info'

// Components
const Card = ({ fields }) => {
  let parseDate = false
  let formattedDate = false

  if (fields.end_date) {
    parseDate = parseISO(fields.end_date)
    formattedDate = format(new Date(parseDate), 'd MMMM yy')
  }

  return (
    <li className='component-card ease group relative z-0 my-4 mx-2 flex w-60 flex-grow transform flex-col md:w-72 xl:w-80'>
      {fields.image.gatsbyImageData && (
        <div className='relative'>
          <div className='relative flex-shrink-0 overflow-hidden'>
            <GatsbyImage className='transition duration-300 ease-in-out group-hover:scale-105' image={fields.image.gatsbyImageData} alt={fields.image.alt || ''} />
          </div>
          {fields.event_type && (
            <div className='flex flex-col items-start font-extrabold leading-tight justify-center px-6 py-3 w-full text-white z-10 bg-brand-orange absolute bottom-0 inset-x-0'>
              {fields.event_type}
            </div>
          )}
        </div>
      )}
      <div className='flex flex-grow flex-col bg-white px-6 pt-3'>
        <div className='prose text-brand-blue'>
          <h3 className='my-0'>{fields.title.text}</h3>
          {fields.end_date && <div className='text-brand-orange'>{formattedDate}</div>}
          <p>{fields.description}</p>
        </div>
        <div className='mt-auto py-6'>
          <PrismicLink className='button button-default' field={fields.link}>
            View <span className='sr-only'>{fields.title.text}</span>
            <span className='absolute inset-0 cursor-pointer' aria-hidden='true'></span>
          </PrismicLink>
        </div>
      </div>
    </li>
  )
}

const auctionCalendar = ({ slice }) => {
  // let showDots = false
  let showArrows = false
  let loop = false
  if (slice.items.length > 2) {
    // showDots = true
    showArrows = true
    loop = true
  }
  return (
    <section className='component-auction_calendar overflow-hidden max-w-screen-xl mx-auto md:px-6 py-8 md:py-10'>
      <div className='flex flex-col items-center justify-center px-6'>
        {slice.primary.title.text && (
          <div className='prose prose-lg mx-auto w-full text-center underline underline-offset-8 decoration-brand-orange'>
            <PrismicRichText field={slice.primary.title.richText} />
          </div>
        )}
      </div>
      <div className='max-w-screen-xl mx-auto text-brand-orange'>
        {slice.items.length > 1 ? (
          <EmblaCarousel arrows={showArrows} autoPlay={false} delayLength={4000} dots={false} thumbs={false} loop={loop}>
            {slice.items.map((card, index) => {
              return (
                <div key={`item-${index}`} className='flex'>
                  <Card fields={card} />
                </div>
              )
            })}
          </EmblaCarousel>
        ) : (
          <div className='relative flex items-center bg-info p-8 text-center text-xl text-info'>
            <Info className='mr-1 h-10 w-10' />
            <strong>There are no auctions currently</strong>, subscribe to our newsletter to get the latest auction news directly by email
          </div>
        )}
      </div>
    </section>
  )
}

auctionCalendar.propTypes = {
  slice: PropTypes.object.isRequired
}

export default auctionCalendar
